import { render, staticRenderFns } from "./logHeader.vue?vue&type=template&id=2d82552e&"
import script from "./logHeader.vue?vue&type=script&lang=js&"
export * from "./logHeader.vue?vue&type=script&lang=js&"
import style0 from "./logHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports